import _http from "./httpService";

export function checkServiceability(body) {
  return _http.post("user/zone/checkServiceability", body);
}
